module.exports = __webpack_public_path__ + "img/jypx-3.50455ade.webp";